import { useCrossSellWidgetContext } from '../cross-sell/components/CrosssellWidgetProvider/CrosssellWidgetProvider'
import { useGlobalConfigContext } from '../global-config/context/globalConfigContext'

import {
  EXPERIMENTS_TRACK_EVENT_CROSSSELL_INJECTION_SPONSORED_CSW_PRODUCT,
  EXPERIMENTS_TRACK_EVENT_PDP_CSW_PRODUCT,
} from './eventTracking/EXPERIMENTS_TRACK_EVENT'
import { experimentsTrackEvent } from './eventTracking/experimentsTrackEvent'
import { useGetExperiment } from './hooks'
import { EXPERIMENT_NAME_PDP_CROSSSELL_INJECTION } from './model/EXPERIMENT_NAME'

export const useExperimentsTrackEventCrossSellInjection = (): {
  experimentsTrackEventCrossSellInjection: (isFirst: boolean) => void
} => {
  const config = useGlobalConfigContext()
  const { widgetId } = useCrossSellWidgetContext()
  const { isEnabled } = useGetExperiment(
    EXPERIMENT_NAME_PDP_CROSSSELL_INJECTION,
  )

  const experimentsTrackEventCrossSellInjection = (isFirst: boolean): void => {
    const CROSS_SELL_PDP_CENTER_SLIDER_COM_DE_ID = 297

    const eventName = isFirst
      ? `${EXPERIMENTS_TRACK_EVENT_CROSSSELL_INJECTION_SPONSORED_CSW_PRODUCT} ${widgetId}`
      : `${EXPERIMENTS_TRACK_EVENT_PDP_CSW_PRODUCT} ${widgetId}`

    if (isEnabled && widgetId === CROSS_SELL_PDP_CENTER_SLIDER_COM_DE_ID) {
      experimentsTrackEvent(config, eventName)
    }
  }

  return { experimentsTrackEventCrossSellInjection }
}
